<template>
  <v-dialog v-model="dialog" width="800" @click:outside="close">
    <v-card>
      <v-toolbar dense color="red lighten-1">
        <v-toolbar-title class="white--text">{{ title }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <slot />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'FormDialog',
  props: {
    title: { type: String, default: '' },
    dialog: { type: Boolean, default: false },
    submit: { type: Function, default: (data) => console.log(data) },
    close: { type: Function, default: () => {} },
  },
  data: () => {
    return {}
  },
}
</script>
